var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { useNavigator, usePathIndex } from 'hx-navigator';
import { SideImageLayout } from 'hx-ui';
import { Footer } from '@/components/footer.component';
import { HearingAidSimulator } from '@/components/hearing-aid-simulator.component';
import { LogoAndHeading } from '@/components/logo-and-heading.component';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { isResultsCategory } from '@/components/results-category/helpers/is-results-category.helper';
import { categoryPathMap } from '@/components/results-category/constants/category-path-map.constant';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { OverLayBanner } from '@/components/overlay-banner.component';
import { useLocation } from 'react-router-dom';
export function HearingAidSimulatorPage() {
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    var basePath = usePathIndex().basePath;
    var path = !!category && isResultsCategory(category)
        ? "".concat(basePath, "/result-category/").concat(categoryPathMap[category])
        : "/".concat(basePath);
    var navigate = useNavigator().navigate;
    var location = useLocation();
    return (_jsx(SideImageLayout, { imageLeft: pageImages.earWithSoundWaves, leftPanelWidth: "40%", header: _jsx(LogoAndHeading, { headingText: 'Hearing aid simulator', image: {
                height: 110,
                width: 118,
            }, className: "text-2xl font-bold mt-10" }), overlayedContent: _jsx(OverLayBanner, { content: _jsx(Button, __assign({ variant: "text", className: "underline underline-offset-2 text-white", onClick: function () {
                    return navigate('/disclaimer', {
                        state: { from: location.pathname },
                    });
                } }, { children: "Disclaimer" })), className: "bg-banner-blue text-center text-xl font-bold text-white py-1" }), content: _jsx(HearingAidSimulator, {}), nav: _jsxs(NavigationButtonsContainer, __assign({ className: 'pb-10' }, { children: [_jsx(NavigationButton, { variant: "outlined", label: "Previous", navigate: path }), _jsx(Button, __assign({ variant: "contained", href: "https://www.bestbuy.com/site/hearing-aids-amplifiers/hearing-aids/pcmcat1616614505031.c?id=pcmcat1616614505031", target: "_blank", rel: "noreferrer noopener", className: 'sm:w-60 sm:max-w-60 py-3 w-full disabled:bg-primary/40 text-center' }, { children: "Shop for hearing aids" }))] })), footer: _jsx(Footer, {}) }));
}
